import { Style } from '../types/flux';

export const stylesList: Style[] = [
  {
    value: 'white_painted',
    text: 'White Painted',
    img: 'https://via.placeholder.com/150/FFFFFF?text=White+Painted',
  },
  {
    value: 'white_wood',
    text: 'White Wood Siding',
    img: 'https://via.placeholder.com/150/FFFFFF?text=White+Wood+Siding',
  },
  {
    value: 'combined_white_wood',
    text: 'Combined White Painted and Natural Wooden Siding',
    img: 'https://via.placeholder.com/150/FFFFFF?text=Combined+White+and+Wood',
  },
  {
    value: 'yellow_wood',
    text: 'Yellow Nature Wood Siding',
    img: 'https://via.placeholder.com/150/FFFF99?text=Yellow+Wood+Siding',
  },
  {
    value: 'blue_wood',
    text: 'Light Blue Wood Siding',
    img: 'https://via.placeholder.com/150/ADD8E6?text=Blue+Wood+Siding',
  },
  {
    value: 'green_wood',
    text: 'Light Green Wood Siding',
    img: 'https://via.placeholder.com/150/90EE90?text=Green+Wood+Siding',
  },
  {
    value: 'hip_roof',
    text: 'Hip Roof',
    img: 'https://via.placeholder.com/150/FFA07A?text=Hip+Roof',
  },
  {
    value: 'gable_roof',
    text: 'Gable Roof',
    img: 'https://via.placeholder.com/150/FFA07A?text=Gable+Roof',
  },
  {
    value: 'flat_roof',
    text: 'Flat Roof',
    img: 'https://via.placeholder.com/150/808080?text=Flat+Roof',
  },
  {
    value: 'has_garage',
    text: 'Has garage',
    img: '',
  },
];
